/**
 * Gsap JavaScript singleton module
 */


var Gsap = (function($) {
gsap.registerPlugin(ScrollTrigger);

  function initGsapBanners() {
    // do something
    const tlBanners = gsap.timeline({
    scrollTrigger: {
        trigger: ".banner-bottom", // selector or element
        start: "top 80%",  // [trigger] [scroller] positions
       
        markers: false, // only during development!
        toggleActions: "play pause resume reset",
        // other actions: complete reverse none
        toggleClass: "active"
        //once: true      
    }
    });

    gsap.utils.toArray(".banner").forEach((banner, i) => {
        banner.bg = banner.querySelector(".banner--bg"); 
            
        // Do the parallax effect on each section
        if (i) {
            banner.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;
      
          gsap.to(banner.bg, {
            backgroundPosition: `50% ${innerHeight / 2}px`,
            ease: "none",
            scrollTrigger: {
              trigger: banner,
              scrub: true
            }
          });
        } 
        
        // the first image should be positioned against the top. Use px on the animating part to work with GSAP. 
        else {
        banner.bg.style.backgroundPosition = "50% 0px"; 
      
          gsap.to(banner.bg, {
            backgroundPosition: `50% ${innerHeight / 2}px`,
            ease: "none",
            scrollTrigger: {
              trigger: banner,
              start: "top 10%", 
              end: "bottom top",
              scrub: true
            }
          });
        }
      });
  }

  function initGsapCorners() {

    var x = window.matchMedia("(max-width: 900px)")
    
    if (x.matches) { 
      gsap.to(".corners--right .corners__image", {
        backgroundPosition: "50% 100%",
        backgroundSize: "130% 130%",
        ease: "none",
        scrollTrigger: {
          trigger: ".corners__image",
          start: "center bottom",
          end: "400% top",
          scrub: true
        }
      });
    } else {
      gsap.to(".corners--right .corners__image", {
        backgroundPosition: "50% 100%",
        backgroundSize: "130% 130%",
        ease: "none",
        scrollTrigger: {
          trigger: ".corners__image",
          start: "center bottom",
          end: "bottom top",
          scrub: true
          
        }
      });
    }

    gsap.from(".corners--left .corners__image", {
      backgroundPosition: "50% 100%",
      //backgroundSize: "100% 100%",
      ease: "none",
      scrollTrigger: {
        trigger: ".corners__image",
        start: "-50% bottom",
        end: "bottom top",
        scrub: true
      }
    });

  }
 

  function initGsapBlocks() {

    ScrollTrigger.batch(".block--animate", {
      onEnter: (elements, triggers) => {
        gsap.from(elements, {y: 100, stagger: 0.25});
      },
      
    });

    ScrollTrigger.batch(".text--animate", {
      start: "60% bottom",
      once: true,
      onEnter: (elements, triggers) => {
        gsap.from(elements, {y: 100});
        gsap.to(elements, {opacity: 1});
      },
      
    });

  }

  function initGsapHero() {
   
    gsap.to(".about-hero .title", {y: -40, duration: 1, ease: Power2.easeOut, delay: 0.2});
    gsap.to(".about-hero .title", {opacity: 1, duration: 0.5, ease: Power2.easeOut, delay: 0.2});
    gsap.to(".about-hero .subtitle", {y: -40, duration: 1.2, ease: Power2.easeOut, delay: 0.4});
    gsap.to(".about-hero .subtitle", {opacity: 1, duration: 0.5, ease: Power2.easeOut, delay: 0.4});
    gsap.from("#brush", {y: -100, ease: Power2.easeOut, duration: 1.5});
    gsap.to("#brush", {opacity: 1, ease: Power2.easeOut, duration: 0.5});

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#brush",
        scrub: true,
        pin: false,
      },
    }); 
    tl.from("#brush", {
      yPercent: -15,
      ease: "none",
    }).to("#brush", {
      yPercent: 15,
      ease: "none",
    }); 

  }



  function init() {

    initGsapBanners();
    initGsapBlocks();
    initGsapCorners();
    initGsapHero();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Gsap.init);
